/**
 * @generated SignedSource<<5f794430227429c0c6b23140ec6e7b70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastAdminButton_Dashboard$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StorecastAdminPopoverSectionDashboard_Dashboard">;
  readonly " $fragmentType": "StorecastAdminButton_Dashboard";
};
export type StorecastAdminButton_Dashboard$key = {
  readonly " $data"?: StorecastAdminButton_Dashboard$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastAdminButton_Dashboard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastAdminButton_Dashboard",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorecastAdminPopoverSectionDashboard_Dashboard"
    }
  ],
  "type": "Dashboard",
  "abstractKey": null
};

(node as any).hash = "68a2178504ac20b065086bb30faebc97";

export default node;
